import { useAuth } from "@/context/AuthContext";
import { LOGO_FULL } from "@/lib/api";
import { Shield, Mail, Building2 } from "lucide-react";

export default function Settings() {
  const { user } = useAuth();
  return (
    <div className="space-y-6 animate-fade-up max-w-3xl">
      <div><h1 className="text-3xl sm:text-4xl font-heading font-bold text-navy">Settings</h1><p className="text-slate-500 mt-1">Company & account information</p></div>

      <div className="bg-navy rounded-2xl p-8 shadow-sm flex flex-col items-center text-center">
        <img src={LOGO_FULL} alt="True Seal Caulking" className="h-24 object-contain" />
        <p className="text-slate-300 text-sm tracking-[0.25em] uppercase mt-3">Sealed Right. Built To Last.</p>
      </div>

      <div className="bg-white rounded-2xl border border-slate-100 p-6 shadow-sm space-y-4">
        <h2 className="font-heading font-semibold text-navy">Company Details</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-sm">
          <div className="flex items-center gap-3"><Building2 className="w-5 h-5 text-slate-400" /><div><p className="text-slate-400 text-xs uppercase tracking-wider">Company</p><p className="font-medium text-navy">True Seal Caulking</p></div></div>
          <div className="flex items-center gap-3"><Shield className="w-5 h-5 text-slate-400" /><div><p className="text-slate-400 text-xs uppercase tracking-wider">Region</p><p className="font-medium text-navy">Australia</p></div></div>
        </div>
      </div>

      <div className="bg-white rounded-2xl border border-slate-100 p-6 shadow-sm space-y-4">
        <h2 className="font-heading font-semibold text-navy">Your Account</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-sm">
          <div className="flex items-center gap-3"><div className="w-10 h-10 rounded-full bg-navy text-white flex items-center justify-center font-semibold">{user?.name?.[0]}</div><div><p className="font-medium text-navy">{user?.name}</p><p className="text-slate-400 capitalize text-xs">{user?.role}</p></div></div>
          <div className="flex items-center gap-3"><Mail className="w-5 h-5 text-slate-400" /><div><p className="text-slate-400 text-xs uppercase tracking-wider">Email</p><p className="font-medium text-navy">{user?.email}</p></div></div>
        </div>
      </div>
    </div>
  );
}
